import {CommonBadlXlsxDataProcessor} from '../export-care-plan-common-badl-xlsx-data';

export class PersonalHygieneXlsxDataProcessor extends CommonBadlXlsxDataProcessor {
  // Inherits the same headers and row structure as Common processor.
}
